/**
 * Typed querySelector shorthand.
 * Throws if element is missing, so callers never deal with null.
 */
export function qs<T extends HTMLElement = HTMLElement>(
  selector: string,
  root: ParentNode = document,
): T {
  const el = root.querySelector<T>(selector)
  if (!el) throw new Error(`Element not found: "${selector}"`)
  return el
}

/** querySelector that returns null instead of throwing */
export function qsMaybe<T extends HTMLElement = HTMLElement>(
  selector: string,
  root: ParentNode = document,
): T | null {
  return root.querySelector<T>(selector)
}

/** getElementById with type assertion */
export function byId<T extends HTMLElement = HTMLElement>(id: string): T {
  const el = document.getElementById(id) as T | null
  if (!el) throw new Error(`#${id} not found`)
  return el
}

/** byId that returns null instead of throwing */
export function byIdMaybe<T extends HTMLElement = HTMLElement>(id: string): T | null {
  return document.getElementById(id) as T | null
}

/** Create element with optional className and inner HTML */
export function el<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  options?: { className?: string; html?: string; text?: string },
): HTMLElementTagNameMap[K] {
  const elem = document.createElement(tag)
  if (options?.className) elem.className = options.className
  if (options?.html !== undefined) elem.innerHTML = options.html
  if (options?.text !== undefined) elem.textContent = options.text
  return elem
}

/** Show a floating toast message */
export function showToast(msg: string, durationMs = 2200): void {
  document.querySelector('.toast')?.remove()
  const toast = el('div', { className: 'toast', text: msg })
  document.body.appendChild(toast)
  setTimeout(() => toast.remove(), durationMs)
}
